import { render, staticRenderFns } from "./MrpaNotaryDocument.vue?vue&type=template&id=87fa6e34&"
import script from "./MrpaNotaryDocument.vue?vue&type=script&lang=js&"
export * from "./MrpaNotaryDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports